import { SpotlightModel, spotlightModelInitial } from './SpotlightModel';

export interface SpotlightBatchModel {
    spotlight: SpotlightModel,
    categoriesId: number[]
}

export const spotlightBatchModelInitial: SpotlightBatchModel = {
    spotlight: spotlightModelInitial,
    categoriesId: []
};